import { render, staticRenderFns } from "./ImportDelivery.vue?vue&type=template&id=5c1d1bce"
import script from "./ImportDelivery.vue?vue&type=script&lang=js"
export * from "./ImportDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports